import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface GeometricFieldProps {
    className?: string
}

/* Architectural line drawing: a grid of construction lines, arcs and one coral sun. */
export const GeometricField: FC<GeometricFieldProps> = ({ className }): ReactNode => {
    const columns = [80, 160, 240, 320, 400, 480]
    const arcs = [120, 180, 240, 300]

    return (
        <svg
            viewBox='0 0 560 560'
            fill='none'
            aria-hidden='true'
            className={cn('[&_*]:[vector-effect:non-scaling-stroke]', className)}
        >
            <g stroke='currentColor' strokeWidth='1' opacity='0.35'>
                {columns.map((x) => (
                    <line key={`v-${x}`} x1={x} y1='0' x2={x} y2='560' />
                ))}
                {columns.map((y) => (
                    <line key={`h-${y}`} x1='0' y1={y} x2='560' y2={y} />
                ))}
            </g>

            <g stroke='currentColor' strokeWidth='1.25'>
                {arcs.map((radius) => (
                    <path key={radius} d={`M ${280 - radius} 480 A ${radius} ${radius} 0 0 1 ${280 + radius} 480`} />
                ))}
                <line x1='40' y1='480' x2='520' y2='480' />
                <line x1='280' y1='60' x2='280' y2='480' strokeDasharray='4 8' />
                <path d='M 100 480 L 280 180 L 460 480' />
            </g>

            <circle cx='380' cy='170' r='58' className='fill-coral' />
            <rect x='96' y='96' width='48' height='48' stroke='currentColor' strokeWidth='1.25' />
            <rect x='108' y='108' width='24' height='24' fill='currentColor' />
            <circle cx='280' cy='180' r='5' fill='currentColor' />
        </svg>
    )
}
